import React from 'react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import PublicLayout from '../../../layouts/public';
import { lzGetAssetUrl, lzShowSuccessMessage } from '../../../../services/LzUtils';
import ImgLogo from '../../../../assets/images/logo.png';
import ImgLzLogo from '../../../../assets/images/lz-logo.png';
import { Link } from 'react-router-dom';
import { lzCallApi } from '../../../../services/LzApiService';

class RegisterScreen extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      model: {
        name: '',
        email: '',
        wp: '',
        wp_confirmation: '',
      },
    };
  }

  handleInputChange = (name, value) => {
    this.setState({ [name]: value });
  };

  onSubmit(evt) {
    evt.preventDefault();
    this.callRegisterApi();
  }

  async callRegisterApi() {
    const { history } = this.props;
    const { model } = this.state;

    // Make the api call and get processed data
    const data = await lzCallApi('register', model, 'post');

    // Validate data and redirect
    if (data) {
      history.push('/user/confirm-email/' + data.email);
      lzShowSuccessMessage('Please check your email for confirmation code!');
    }
  }

  render() {
    const { model } = this.state;

    return (
      <PublicLayout>
        <div className="full-page-form">
          <Card className="card">
            <div className="half-form bg-signin">
              <form noValidate autoComplete="off" onSubmit={(evt) => this.onSubmit(evt)}>
                <img src={lzGetAssetUrl(ImgLogo)} alt="Logo" className="logo" />

                <h2>Dealer Sign-Up</h2>

                <FormGroup row>
                  <TextField fullWidth variant="outlined" label="Your Full Name" helperText="enter your full name here"
                    value={model.name} onChange={(ev) => this.setState({ model: Object.assign({}, model, { name: ev.target.value }) })}
                  />
                </FormGroup>

                <FormGroup row>
                  <TextField fullWidth variant="outlined" label="Email Address" helperText="enter email address as username"
                    value={model.email} onChange={(ev) => this.setState({ model: Object.assign({}, model, { email: ev.target.value }) })}
                  />
                </FormGroup>

                <FormGroup row>
                  <TextField fullWidth variant="outlined" label="Create Password" type="password" value={model.wp}
                    onChange={(ev) => this.setState({ model: Object.assign({}, model, { wp: ev.target.value }) })}
                  />
                </FormGroup>

                <FormGroup row>
                  <TextField fullWidth variant="outlined" label="Confirm Password" type="password" value={model.wp_confirmation}
                    onChange={(ev) => this.setState({ model: Object.assign({}, model, { wp_confirmation: ev.target.value }) })}
                  />
                </FormGroup>

                <FormGroup row>
                  <Grid container>
                    <Grid item xs={4}>
                      <Button type="submit" variant="contained" color="primary">Sign-Up</Button>
                    </Grid>
                    <Grid item xs={8} style={{ textAlign: 'right', marginTop: 12 }}>
                      {<Link to={'/user/login'}>Sign-In if already have an account.</Link>}
                    </Grid>
                  </Grid>
                </FormGroup>

                <FormGroup row>
                  <Grid container>
                    <Grid item xs={12} style={{ textAlign: 'right', marginTop: 12 }}>
                      <Link to={'/user/confirm-email'}>Enter confirmation code if already received via email.</Link>
                    </Grid>
                  </Grid>
                </FormGroup>
              </form>
            </div>
          </Card>
          <a href="https://logic-zone.net/?ref=firearmdistributors" target="_blank" rel="noreferrer" className="powered-by">
            Powered by :
            <img src={lzGetAssetUrl(ImgLzLogo)} alt="Logic-Zone" />
          </a>
        </div>
      </PublicLayout>
    );
  }

}

export default RegisterScreen;
